import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import i18n from "@/i18n";

export const vbsSyncWarningsKey = ["ondersteuners", "vbs-sync-warnings"] as const;

/**
 * The ondersteuners the last VBS run could not import. Beheerder-only on the API, and read on
 * the ondersteuner screen so "90 of 100 arrived" is something a beheerder can act on rather
 * than a silence.
 */
export function useVbsSyncWarnings() {
  return useQuery({
    queryKey: vbsSyncWarningsKey,
    queryFn: async () => {
      const { data, response } = await api.GET("/api/ondersteuners/vbs-sync-warnings");
      if (!data) throw new Error(i18n.t("common:errors.unexpected", { status: response.status }));
      return data;
    },
  });
}
